// removes null, undefined and empty strings from an object recursively
export const cleanObject = <T extends Record<string, any>>(
  obj: T
): Partial<T> => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(
        ([, value]) => value !== null && value !== undefined && value !== ""
      )
      .map(([key, value]) => {
        // Recursively clean nested objects
        if (value && typeof value === "object" && !Array.isArray(value)) {
          return [key, cleanObject(value)];
        }
        // Recursively clean arrays
        if (Array.isArray(value)) {
          return [
            key,
            value
              .map((item) =>
                typeof item === "object" && item !== null
                  ? cleanObject(item)
                  : item
              )
              .filter(
                (item) => item !== null && item !== undefined && item !== ""
              ),
          ];
        }
        return [key, value];
      })
  ) as Partial<T>;
};
